__turbopack_context__.v({
  "BlackText": "hxjOYG_BlackText",
  "Overflow": "hxjOYG_Overflow",
  "ReduceMotionButton": "hxjOYG_ReduceMotionButton",
  "ReduceMotionButtonWrapper": "hxjOYG_ReduceMotionButtonWrapper",
  "ReduceMotionIcon": "hxjOYG_ReduceMotionIcon",
  "Root": "hxjOYG_Root",
  "StopAnimations": "hxjOYG_StopAnimations",
});
